import React from 'react';
import Header from "../components/Header";
import Search from "../components/Search";

const Main = () => {
    return (
        <div>
            <Header />
            <Search />
        </div>
    );
    }

export default Main;